<template>
  <div class="header-box">
    <div class="header-box-left">
      <div class="header-box-menu-icon" @mouseenter="showSideMenu">
        <i class="iconfont icon-gongneng" />
      </div>
      <img
        class="header-box-logo"
        src="~@/assets/images/login/srm-logo.png"
        @click="goHome"
      >
      <h3 v-if="!ifSetting" class="header-box-setting-title">
        | {{ $t('common.settingTitle') }}
      </h3>
    </div>

    <div class="header-box-right">
      <el-select class="header-box-select" :value="dbName" placeholder="请选择" size="mini" style="margin-right: 10px; width: 170px;" @change="changeDbSet">
        <span slot="prefix" style="font-size: 12px; line-height: 26px;">切换公司</span>
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div class="header-box-cell">
        <i class="iconfont icon-homepage" @click="goHome" />
      </div>
      <div class="header-box-cell">
        <i class="iconfont icon-news" />
      </div>
      <div class="header-box-cell">
        <i class="iconfont icon-novice_guide" />
      </div>
      <div class="header-box-cell">
        <i class="iconfont icon-qr_code" />
      </div>
      <div class="header-box-cell">
        <lang-select class="set-language" @change="selectChange" />
      </div>
      <el-avatar class="header-box-avatar" :size="24" :src="defaultAvatar" />
      <el-dropdown :tabindex="-1" @command="command">
        <span class="header-box-name">
          {{ userInfo.name }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="info">
            <div class="header-box-dropitem">{{ $t('common.userInfo') }}</div>
          </el-dropdown-item>
          <el-dropdown-item v-if="ifSetting" command="setting">
            <div class="header-box-dropitem">
              {{ $t('common.userSettings') }}
            </div>
          </el-dropdown-item>
          <el-dropdown-item divided command="signout">
            <div class="header-box-dropitem">{{ $t('common.userLogout') }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="header-box-tag">
        <i class="bg-icon iconfont icon-role_background" />
        <span class="bg-text">{{ tipTetx }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/plugin/axios'
import defaultAvatar from '@/assets/images/default_avatar.png'
import LangSelect from '@/components/select/lang-select/index'
// import http from '@plugin/axios'
// import '@/api/dbName/index'
import { resetRouter } from '@plugin/router'
export default {
  components: {
    LangSelect
  },
  data() {
    return {
      options: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    supDistinguish() {
      return this.$store.getters.supDistinguish
    },
    tipTetx() {
      const text = [null, 'common.purchasers', 'common.supplier'][
        this.supDistinguish
      ]
      return text && this.$t(text)
    },
    ifSetting() {
      return (
        this.$route.matched[0] && this.$route.matched[0].name !== 'Root.Setting'
      )
    },
    defaultAvatar() {
      return defaultAvatar
    },
    homePath() {
      return this.ifSetting ? '/' : '/setting'
    },
    dbName: {
      get() {
        return this.$store.getters.dbName
      },
      set(value) {
        return this.$store.commit('app/SET_DBNAME', value)
      }
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    showSideMenu() {
      this.$emit('open')
    },
    command(event) {
      this[event]()
    },
    info() {
      this.$router.push({
        name: 'Personal.Data',
        params: { id: this.userInfo.id }
      })
    },
    async setting() {
      if (!this.ifSetting) return
      const routeData = this.$router.resolve({ name: 'Root.Setting' })
      window.open(routeData.href, '_blank')
    },
    async signout() {
      const supDistinguish = this.supDistinguish
      await this.$store.dispatch('app/exit')
      this.$router.push({
        name: 'Sign.Login',
        query: { redirect: this.$route.fullPath },
        params: { supDistinguish: supDistinguish }
      })
    },
    async selectChange() {
      await resetRouter()
    },
    goHome() {
      if (this.$route.name.includes('Dashboard')) return
      this.$router.push(this.homePath)
    },
    async changeDbSet(event) {
      await http({
        url: '/changeDbSet',
        baseURL: process.env.VUE_APP_BASE_API,
        data: {
          dbName: event
        }
      })
      this.dbName = event
      this.$emit('refresh')
    },
    async getInfo() {
      const res = await http({
        url: '/srmDBSettings/getSrmDBGroupList',
        baseURL: process.env.VUE_APP_BASE_API,
        data: { dbName: this.$store.getters.dbName }
      })
      this.options = res.map(item => ({
        value: item.dbName,
        label: item.dbNamed
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.header-box {
  background: #ffffff;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &-left,
  &-right {
    height: 100%;
    display: flex;
    align-items: center;
  }
  &-menu-icon {
    width: 60px;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f3f5f6;
    color: #c0cddc;
    &:hover {
      background-color: #f0f0f0;
    }
  }

  &-logo {
    height: 25px;
    margin-left: 20px;
    cursor: pointer;
  }

  &-setting-title {
    margin-left: 10px;
    color: #303133;
  }

  &-cell {
    cursor: pointer;
    padding: 0 10px;
    color: #333;
    &:hover {
      color: #008ee3;
    }
  }

  &-avatar {
    margin-left: 10px;
  }

  &-name {
    padding: 0 10px;
    cursor: pointer;
    color: #333;
  }
  &-dropitem {
    width: 60px;
    text-align: center;
  }
  &-tag {
    position: relative;
    display: inline-flex;
    padding: 0 10px;
    transform: translateX(-5px);
    margin-right: 15px;
    .bg-text {
      position: relative;
      z-index: 10;
      color: #ffffff;
    }
    .bg-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #008ee3;
      font-size: 24px;
    }
  }
}
.header-box {
  /deep/ {
    .header-box-select.el-select {
      .el-input__prefix {
        right: 35px;
        left: auto;
      }
      .el-input__inner {
        padding-left: 10px;
        padding-right: 90px;
        border: none;
      }
    }
  }
}
</style>
